import { request } from '@/restapi/restapi.base.js';


let compiledEmailTmpl;
let compiledLdapEmailTmpl;

function compile(emails) {
    let result = (it) => false;

    if (emails == null)
        return result;

    for (const email of emails) {
        const template = email.replace(/[-\/\\^$*+?.()|[\]{}]/g, (m) => {
            if (m === '*')
                return '[^@]*';
            return '\\' + m;
        });
        const regexp = new RegExp('^[^@]+@' + template + '$', 'i');
        const prev = result;
        result = (it) => prev(it) || regexp.test(it);
    }

    return result;
}

/**
 * Получить список допустимых email
 */
export async function allowedEmail(email) {
    if (!email)
        return true;

    if (compiledEmailTmpl != null)
        return compiledEmailTmpl(email);

    const { result } = await request('/api/config/allowed_emails/get', {}, {
        messages: false,
    });

    compiledEmailTmpl = compile(result);

    return compiledEmailTmpl(email);
}


const ldapEmails = [ '*.rt.ru', 'rt.ru' ];

/**
 * Email требует LDAP авторизации
 */
export function isLdapEmail(value) {
    if (compiledLdapEmailTmpl != null)
        return compiledLdapEmailTmpl(value);

    compiledLdapEmailTmpl = compile(ldapEmails);
    return compiledLdapEmailTmpl(value);
}
